import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/lang-icon.svg")